import { Component } from 'react';
import { ee } from './useEventAction';

export default function observer (events = []) {
	return function (arg1) {
		// 无状态组件
		const componentClass = arg1;
		if (
			typeof componentClass === 'function' &&
			(!componentClass.prototype || !componentClass.prototype.render) &&
			!componentClass.isReactClass &&
			!Object.prototype.isPrototypeOf.call(Component, componentClass)
		) {
			return observer(
				class extends Component {
					static displayName = componentClass.displayName || componentClass.name;
					static contextType = componentClass.contextType;
					static propTypes = componentClass.propTypes;
					static defaultProps = componentClass.defaultProps;
					static events = events;
					render () {
						return componentClass.call(this, this.props, this.context);
					}
				}
			);
		}

		if (!componentClass) {
			throw new Error('请传入合法的组件绑定observer');
		}

		const target = componentClass.prototype || componentClass;
		target.events = events;
		mixinLifecycleEvents(target);
		return componentClass;
	};
}

function mixinLifecycleEvents (target) {
	patch(target, 'componentDidMount', true);
	['dispatch', 'componentWillUnmount'].forEach(function (funcName) {
		patch(target, funcName);
	});
	if (!target.shouldComponentUpdate) {
		target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	}
}

const reactiveMixin = {
	dispatch: function (action) {
		ee.emit(action.type, action);
	},

	componentDidMount: function () {
		if (this.onEventAction) {
			this.listener = action => this.onEventAction(action);
			for (const e of this.events) {
				ee.on(e, this.listener);
			}
		}
	},

	componentWillUnmount: function () {
		if (this.onEventAction) {
			for (const e of this.events) {
				if (this.listener) {
					ee.removeListener(e, this.listener);
				}
			}
		}
	},

	shouldComponentUpdate: function (nextProps, nextState) {
		if (this.state !== nextState) {
			return true;
		}
		return isObjectShallowModified(this.props, nextProps);
	}
};

function patch (target, funcName, runMixinFirst = false) {
	const base = target[funcName];
	const mixinFunc = reactiveMixin[funcName];
	const f = !base
		? mixinFunc
		: runMixinFirst === true
			? function () {
				mixinFunc.apply(this, arguments);
				base.apply(this, arguments);
			  }
			: function () {
				base.apply(this, arguments);
				mixinFunc.apply(this, arguments);
			  };
	target[funcName] = f;
}

function isObjectShallowModified (prev, next) {
	if (prev == null || next == null || typeof prev !== 'object' || typeof next !== 'object') {
		return prev !== next;
	}
	const keys = Object.keys(prev);
	if (keys.length !== Object.keys(next).length) {
		return true;
	}
	let i = keys.length;
	let key;
	while (i--) {
		key = keys[i];
		if (next[key] !== prev[key]) {
			return true;
		}
	}
	return false;
}
